export default __webpack_public_path__ + "static/tutorialPicture1-d979b1d618b11b69f257780030c3edf1.jpg";